import React from 'react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, CTA_LABEL, GUARANTEE_LINE, RATING_LINE } from '../data/site';
export function Hero() {
  const scrollToOffer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('offerta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-cream px-4 pb-6 pt-5" data-id="element-93" data-mp="4na1csbc3y7x">
      <div className="mx-auto max-w-2xl text-center" data-id="element-94" data-mp="12a0mpfljy8wq">
        <p className="mb-2 inline-block rounded bg-brand-navy px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wider text-white sm:text-xs" data-id="element-95" data-mp="128pg780q2n1x">
          Sistema Completo 6-in-1 + 5 Bonus
        </p>

        <h1 className="font-display text-[26px] font-extrabold uppercase leading-[1.1] text-brand-navy sm:text-4xl" data-id="element-96" data-mp="sde1gppbdfu6">
          Il Sistema Completo Pronto all’Uso per{' '}
          <span className="text-brand-green" data-id="element-97" data-mp="3d33gb2q0p1mv">Insegnanti di Inglese</span>
        </h1>

        <p className="mx-auto mt-2.5 max-w-xl text-[15px] font-medium leading-snug text-brand-graphite sm:text-base" data-id="element-98" data-mp="381e0zavri1sz">
          Risparmia ore ogni settimana nella preparazione di lezioni, attività,
          esercizi, conversazioni, materiali e valutazioni con un unico sistema
          completo già organizzato e pronto da utilizzare.
        </p>

        <a href="#offerta" onClick={scrollToOffer} className="mt-3 block" data-id="element-99" data-mp="39cpfz2rm3z6l">
          <img src={BOX_IMAGE} alt="Box ENGLISH TEACHER PRO™ — sistema completo 6-in-1 per insegnanti di inglese" className="mx-auto w-full max-w-sm drop-shadow-2xl sm:max-w-md" data-id="element-100" data-mp="3e7l780p0yiin" />
        </a>

        <div className="mx-auto mt-2 max-w-md" data-id="element-101" data-mp="2qk3muq83ampp">
          <CTAButton data-id="element-102" data-mp="2qleq8oxmhsga">{CTA_LABEL}</CTAButton>
        </div>

        <p className="mt-2.5 text-[13px] font-bold text-brand-graphite" data-id="element-103" data-mp="2vietyt702j48">
          {RATING_LINE}
        </p>
        <p className="text-[13px] font-bold text-brand-graphite" data-id="element-104" data-mp="2hix03zeukfo0">
          {GUARANTEE_LINE}
        </p>
      </div>
    </section>;
}